var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponents = function SvgComponents(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "M21.008 7.28v3.222h0a2.7 2.7 0 0 0-1.4.09 2.61 2.61 0 0 0-1.687 1.836 2.645 2.645 0 0 0 3.088 3.248v3.221a2.11 2.11 0 0 1-2.112 2.112h-3.221v0c.094-.466.062-.95-.091-1.4a2.61 2.61 0 0 0-1.836-1.687A2.645 2.645 0 0 0 10.5 21.01l-3.22-.001a2.11 2.11 0 0 1-2.112-2.111v-3.221q-.261.052-.528.053a2.645 2.645 0 0 1-2.56-3.3 2.61 2.61 0 0 1 1.688-1.836c.45-.154.933-.186 1.4-.091h0V7.28A2.11 2.11 0 0 1 7.28 5.17h3.221a2.645 2.645 0 0 1 3.247-3.088c.859.216 1.55.85 1.836 1.688.154.45.186.934.091 1.4h3.222a2.11 2.11 0 0 1 2.112 2.112",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgComponents;